import { render, staticRenderFns } from "./VideoLearning.vue?vue&type=template&id=45445c98&scoped=true&"
import script from "./VideoLearning.vue?vue&type=script&lang=ts&"
export * from "./VideoLearning.vue?vue&type=script&lang=ts&"
import style0 from "./VideoLearning.vue?vue&type=style&index=0&id=45445c98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45445c98",
  null
  
)

export default component.exports